import { router } from '@/routes/index.js';
import i18n from '@/plugins/i18n.js';

import { storeToRefs } from 'pinia';
import { userStore } from '@/stores/user.js';
import { permissionStore } from '@/stores/permission.js';

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('_token');
  const allowGuest = to.meta.guest;

  if (allowGuest || token) {
    next();
  } else {
    next({ name: 'login' });
  }
});

router.beforeEach((to, from, next) => {
  const title = i18n.global.t(`route.${to?.name}`);
  window.document.title = `${title} | Customer Data Platform - CDP`;
  next();
});

router.afterEach(async (to) => {
  const requiresAuth = to.meta.requiresAuth;

  if (requiresAuth) {
    const storeUser = await userStore();
    const storePermission = await permissionStore();

    const { getAccountCurrent } = storeUser;
    const { getOwnPermission, getPermissionBoard } = storePermission;

    const { isLogin } = storeToRefs(storeUser);
    if (!isLogin.value) {
      await Promise.all([getAccountCurrent(), getPermissionBoard(), getOwnPermission()]);
    }
  }
});
